/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/franchise'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import Franchise from '@routes/Franchise';

export const Route = createFileRoute('/franchise')({
  staticData: { layout: { landingFooter: true, withoutHeader: true, withoutFooter: true } },
  component: () => (
    <CacheDataRoute component={Franchise} path='/franchise' />
  )
});
